"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.showAccountShareDialog = exports.showConfirmationDialog = exports.showManageMembersDialog = exports.showInviteSentDialog = exports.showShareFinancesDialog = exports.DIALOG_TYPE_ACCOUNT_SHARE = exports.DIALOG_TYPE_CONFIRMATION_NEW = exports.DIALOG_TYPE_MANAGE_MEMBERS = exports.DIALOG_TYPE_INVITE_SENT = exports.DIALOG_TYPE_SHARE_FINANCES = void 0;
const redux_actions_1 = require("redux-actions");
const immutable_1 = require("immutable");
const root_ui_1 = require("companion-app-components/flux/root-ui");
exports.DIALOG_TYPE_SHARE_FINANCES = 'SHARE_FINANCES_DIALOG';
exports.DIALOG_TYPE_INVITE_SENT = 'INVITE_SENT_DIALOG';
exports.DIALOG_TYPE_MANAGE_MEMBERS = 'MANAGE_MEMBERS_DIALOG';
exports.DIALOG_TYPE_CONFIRMATION_NEW = 'CONFIRMATION_NEW_DIALOG';
exports.DIALOG_TYPE_ACCOUNT_SHARE = 'ACCOUNT_SHARE_DIALOG';
exports.showShareFinancesDialog = (0, redux_actions_1.createAction)(root_ui_1.rootUiActions.createDialog.toString(), (props) => root_ui_1.rootUiTypes.mkRootUiData({
    type: exports.DIALOG_TYPE_SHARE_FINANCES,
    id: exports.DIALOG_TYPE_SHARE_FINANCES,
    props: (0, immutable_1.Map)(props),
}));
exports.showInviteSentDialog = (0, redux_actions_1.createAction)(root_ui_1.rootUiActions.createDialog.toString(), (props) => root_ui_1.rootUiTypes.mkRootUiData({
    type: exports.DIALOG_TYPE_INVITE_SENT,
    id: exports.DIALOG_TYPE_INVITE_SENT,
    props: (0, immutable_1.Map)(props),
}));
exports.showManageMembersDialog = (0, redux_actions_1.createAction)(root_ui_1.rootUiActions.createDialog.toString(), (props) => root_ui_1.rootUiTypes.mkRootUiData({
    type: exports.DIALOG_TYPE_MANAGE_MEMBERS,
    id: exports.DIALOG_TYPE_MANAGE_MEMBERS,
    props: (0, immutable_1.Map)(props),
}));
exports.showConfirmationDialog = (0, redux_actions_1.createAction)(root_ui_1.rootUiActions.createDialog.toString(), (props) => root_ui_1.rootUiTypes.mkRootUiData({
    type: exports.DIALOG_TYPE_CONFIRMATION_NEW,
    id: exports.DIALOG_TYPE_CONFIRMATION_NEW,
    props: (0, immutable_1.Map)(props),
}));
exports.showAccountShareDialog = (0, redux_actions_1.createAction)(root_ui_1.rootUiActions.createDialog.toString(), (props) => root_ui_1.rootUiTypes.mkRootUiData({
    type: exports.DIALOG_TYPE_ACCOUNT_SHARE,
    id: exports.DIALOG_TYPE_ACCOUNT_SHARE,
    props: (0, immutable_1.Map)(props),
}));
